module.exports = __webpack_public_path__ + "img/Viber.eee7778.svg";